function scrolledDown() {
	var header = document.getElementById("header");

	window.addEventListener('scroll', function () {
		if (window.scrollY > 16) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
}

export {scrolledDown};
